import { COLOR_PRIMARY } from "./environments";

/** Tema de antd con el color corporativo como color primario (botones, tabs, switches...) */
export const BRAND_THEME = {
  token: { colorPrimary: COLOR_PRIMARY },
};
